"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelGammaBrightnessCorrection = exports.CollectionModelGammaBrightnessCorrectionMutator = void 0;
const brightnessCorrection_1 = require("./brightnessCorrection");
class CollectionModelGammaBrightnessCorrectionMutator extends brightnessCorrection_1.CollectionModelBrightnessCorrectionMutator {
    constructor(brightnessCorrection) {
        super(brightnessCorrection);
    }
    init(exponent) {
        this.brightnessCorrection.brightnessCorrectionState.Mutator.create('gamma');
        this.setExponent(exponent);
    }
    setExponent(exponent) {
        const state = this.getValue();
        state.exponent = exponent;
        this.setValue(state);
    }
}
exports.CollectionModelGammaBrightnessCorrectionMutator = CollectionModelGammaBrightnessCorrectionMutator;
class CollectionModelGammaBrightnessCorrection extends brightnessCorrection_1.CollectionModelBrightnessCorrection {
    constructor() {
        super(...arguments);
        this.tag = CollectionModelGammaBrightnessCorrection.TAG;
        this.Mutator = new CollectionModelGammaBrightnessCorrectionMutator(this);
    }
    static state(id) {
        return {
            id,
            tag: 'gamma',
            exponent: 1,
        };
    }
    static isGamma(t) {
        return t.tag === CollectionModelGammaBrightnessCorrection.TAG;
    }
    get exponent() {
        const state = this.state;
        if (!state) {
            return 1;
        }
        return state.exponent;
    }
}
exports.CollectionModelGammaBrightnessCorrection = CollectionModelGammaBrightnessCorrection;
CollectionModelGammaBrightnessCorrection.TAG = 'gamma';
//# sourceMappingURL=gamma.brightnessCorrection.js.map